import { render, staticRenderFns } from "./CommsFilters.vue?vue&type=template&id=ff49d372&"
import script from "./CommsFilters.vue?vue&type=script&lang=js&"
export * from "./CommsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports